export default __webpack_public_path__ + "static/img_big-mobile-765677a643c9b8dc77577295e377707e.png";